<template>
  <div class="animation">
    <!-- <md-progress-spinner class="md-accent" :md-diameter="20" :md-stroke="2" md-mode="indeterminate"></md-progress-spinner> -->
    <span class="md-accent">

      <!-- <img src="../assets/spin.gif" width="100"/> -->

      <section>
    <div class="dots">
      <span style="--i:1;"></span>
      <span style="--i:2;"></span>
      <span style="--i:3;"></span>
      <span style="--i:4;"></span>
      <span style="--i:5;"></span>
      <span style="--i:6;"></span>
      <span style="--i:7;"></span>
      <span style="--i:8;"></span>
      <span style="--i:9;"></span>
      <span style="--i:10;"></span>
      <span style="--i:11;"></span>
      <span style="--i:12;"></span>
      <span style="--i:13;"></span>
      <span style="--i:14;"></span>
      <span style="--i:15;"></span>
    </div>
  </section>

      <!-- <div class="loader">
        <div class="square" ></div>
        <div class="square"></div>
        <div class="square last"></div>
        <div class="square clear"></div>
        <div class="square"></div>
        <div class="square last"></div>
        <div class="square clear"></div>
        <div class="square "></div>
        <div class="square last"></div>
      </div> -->

      <!-- <div class="sk-cube-grid">
        <div class="sk-cube sk-cube1"></div>
        <div class="sk-cube sk-cube2"></div>
        <div class="sk-cube sk-cube3"></div>
        <div class="sk-cube sk-cube4"></div>
        <div class="sk-cube sk-cube5"></div>
        <div class="sk-cube sk-cube6"></div>
        <div class="sk-cube sk-cube7"></div>
        <div class="sk-cube sk-cube8"></div>
        <div class="sk-cube sk-cube9"></div>
      </div> -->
      <!-- <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div> -->

    </span>
    <div id="bg">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .md-accent {
    margin: 24px;
    position: fixed;
    margin: auto 0px;
    z-index: 14;
    top: 0%;
    left: 50%;
    transform: scale(2) !important;
  }

  .md-progress-spinner.md-theme-default.md-accent .md-progress-spinner-circle {
      stroke: #3e9bf7;
  }

  .animation{
    text-align: center;
  }

  #bg{
    width: 100%;
    height: 105%;
    position: fixed;
    opacity: .5;
    z-index: 12;
    margin-top: -15px;

    background: #595959; /* Old browsers */
    background: -moz-radial-gradient(center, ellipse cover,  #595959 0%, #0e0e0e 100%); /* FF3.6-15 */
    background: -webkit-radial-gradient(center, ellipse cover,  #595959 0%,#0e0e0e 100%); /* Chrome10-25,Safari5.1-6 */
    background: radial-gradient(ellipse at center,  #595959 0%,#0e0e0e 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#595959', endColorstr='#0e0e0e',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
  }
section{
  display: flex;
  height: 100vh;
  width: 100%;
  align-items: center;
  justify-content: center;
  background: #4070f4;
}
section .dots span{
  position: absolute;
  height: 10px;
  width: 10px;
  background: #fff;
  border-radius: 50%;
  transform: rotate(calc(var(--i) * (360deg / 15))) translateY(35px);
  animation: animate 1.5s linear infinite;
  animation-delay: calc(var(--i) * 0.1s);
  opacity: 0;
}
@keyframes animate {
 0%{
   opacity: 1;
 }
 100%{
   opacity: 0;
 }
}

</style>



// WEBPACK FOOTER //
// src/components/Loader.vue